import { Box } from "grid-styled";
import styled from "styled-components";

export const PageWrapper = styled(Box)`
  overflow: hidden;
  height: calc(100vh - 65px);
`;
